import { Pipe, PipeTransform } from "@angular/core";
import { TerritoryFrequencyColorsEnum, TerritoryFrequencyEnum, TerritoryRouteTypeColorsEnum, TerritoryRouteTypeEnum, TerritorySaturationColorsEnum, TerritorySaturationEnum } from "../utilities/enums/TerritoriesEnum";

@Pipe({
    name: 'saturationColor'
})
export class SaturationColorPipe implements PipeTransform {
    transform(saturacion: string) {
        if (!saturacion) {
            return null;
        }
        const saturationValue = Number(saturacion.replace('%', '').trim());
        if (!isNaN(saturationValue)) {
            if (saturationValue < 30) {
                return TerritorySaturationColorsEnum.Baja;
            } else if (saturationValue >= 30 && saturationValue <= 70) {
                return TerritorySaturationColorsEnum.Media;
            } else if (saturationValue > 70) {
                return TerritorySaturationColorsEnum.Alta;
            }
        } else {
            return null;
        }
        // const saturationColor = TerritorySaturationColorsEnum;
        // const saturationEnum = TerritorySaturationEnum;
        
        // const routeTypeValues = Object.values(saturationEnum);
        // const index = routeTypeValues.indexOf(saturation as TerritorySaturationEnum);
        // if (index !== -1) {
        //     const key = Object.keys(saturationEnum)[index];
        //     return saturationColor[key];
        // }else{
        //     const routeTypeKeys = Object.keys(saturationEnum);
        //     routeTypeKeys.forEach(key => {
        //         key.replace(/_/g, ' ');           
        //     });
        //     const index = routeTypeKeys.indexOf(saturation as TerritorySaturationEnum);
        //     if (index !== -1) {
        //         const key = Object.keys(saturationEnum)[index];
        //         return saturationColor[key];
        //     }
        // }
        // return null;
    }
}